import React, {useCallback, useMemo} from "react";
import Typography from "@mui/material/Typography";
import AppPage from "../../widgets/layout/AppPage";
import {getAccountInfo, getCompanyInfo} from "../../../utils/GenericUtils";
import {useSessionStorage} from "../../../utils/hooks/SessionStorageHook";
import {CompanyStyle} from "../../../styles/pages/company/CompanyStyle";
import ReferenteDrawer from "./drawer/ReferenteDrawer";
import AnagraficaReferenteDetailSection from "./section/AnagraficaReferenteDetailSection";
import CreaUtente from "./section/CreaUtente";
import DatiAzienda from "./section/DatiAzienda";
import MailInviate from "./section/MailInviate";
import UtentiAzienda from "./section/UtentiAzienda";
import {UtentiOnlineReport} from "./section/UtentiOnlineReport";

const getCompanyLabel = (companyInfo) => (
	companyInfo?.nome
	|| companyInfo?.name
	|| companyInfo?.id
	|| "Azienda"
);

const ReferenteAzienda = () => {
	const classes = CompanyStyle();
	const companyInfo = getCompanyInfo();
	const accountInfo = getAccountInfo();
	const [stato, setStato] = useSessionStorage("menu", "Dati referente");

	const selectMenuItem = useCallback((item) => {
		setStato(item);
	}, [setStato]);

	const activeSection = useMemo(() => {
		switch (stato) {
			case "Dati azienda":
				return <DatiAzienda classes={classes} idSoggetto={accountInfo?.anagraficaAssociata}/>;
			case "Utenti azienda":
				return <UtentiAzienda classes={classes}/>;
			case "Crea utente":
				return <CreaUtente classes={classes}/>;
			case "Mail inviate":
				return <MailInviate classes={classes}/>;
			case "Utenti online":
				return <UtentiOnlineReport classes={classes}/>;
			case "Dati referente":
			default:
				return <AnagraficaReferenteDetailSection classes={classes} idSoggetto={companyInfo?.referente?.idSoggetto}/>;
		}
	}, [accountInfo?.anagraficaAssociata, classes, companyInfo?.referente?.idSoggetto, stato]);

	return (
		<AppPage
			title="Referente azienda"
			mainClassName={classes.page}
			containerClassName={classes.container}
		>
			<section className={classes.hero}>
				<div>
					<Typography className={classes.eyebrow}>Atlantis workspace</Typography>
					<Typography component="h1" className={classes.heroTitle}>
						Referente azienda
					</Typography>
					<Typography className={classes.heroSubtitle}>
						Gestisci dati aziendali, referente, utenti e sessioni con una vista unica e coerente con la nuova UI.
					</Typography>
				</div>
				<div className={classes.heroStats}>
					<div className={classes.heroStat}>
						<Typography className={classes.statLabel}>Azienda</Typography>
						<strong className={classes.statValue}>{getCompanyLabel(companyInfo)}</strong>
					</div>
					<div className={classes.heroStat}>
						<Typography className={classes.statLabel}>ID azienda</Typography>
						<strong className={classes.statValue}>{companyInfo?.id || "-"}</strong>
					</div>
					<div className={classes.heroStat}>
						<Typography className={classes.statLabel}>Sezione</Typography>
						<strong className={classes.statValue}>{stato}</strong>
					</div>
				</div>
			</section>

			<div className={classes.contentShell}>
				<ReferenteDrawer classes={classes} selectMenuItem={selectMenuItem} stato={stato}/>
				{activeSection}
			</div>
		</AppPage>
	);
};

export default React.memo(ReferenteAzienda);
